// extracted by mini-css-extract-plugin
module.exports = {"browser":"PjSGCk","header":"e5o7XR","controls":"_8lVW5I","control":"_25c5mo"};